var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImplementationBlueprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52.419,
    height: 51.689,
    viewBox: "0 0 52.419 51.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6922",
    "data-name": "Rect\\xE1ngulo 6922",
    width: 52.419,
    height: 51.689,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17494",
    "data-name": "Grupo 17494",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19414",
    "data-name": "Trazado 19414",
    d: "M90.6,33.041a9.091,9.091,0,1,0-1.864-3.148L76.639,36.042",
    transform: "translate(-60.239 -13.985)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19415",
    "data-name": "Trazado 19415",
    d: "M167.113,37.322a2.38,2.38,0,1,1-2.38-2.38A2.381,2.381,0,0,1,167.113,37.322Z",
    transform: "translate(-127.611 -27.465)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19416",
    "data-name": "Trazado 19416",
    d: "M151.813,65.946a4.961,4.961,0,0,1,9.205-.164",
    transform: "translate(-119.327 -49.325)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19417",
    "data-name": "Trazado 19417",
    d: "M4.448,93.163A8.239,8.239,0,1,1,6.129,96",
    transform: "translate(-3.144 -64.649)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_471",
    "data-name": "Elipse 471",
    cx: 2.147,
    cy: 2.147,
    r: 2.147,
    transform: "translate(6.939 20.91)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19418",
    "data-name": "Trazado 19418",
    d: "M23.033,125.617a4.475,4.475,0,0,1,8.278-.087",
    transform: "translate(-18.104 -96.521)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19419",
    "data-name": "Trazado 19419",
    d: "M114.044,161.671a8.668,8.668,0,1,1,1.769,2.987",
    transform: "translate(-89.27 -118.049)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19420",
    "data-name": "Trazado 19420",
    d: "M148,168.72a2.259,2.259,0,1,1-2.259-2.259A2.259,2.259,0,0,1,148,168.72Z",
    transform: "translate(-112.78 -130.841)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19421",
    "data-name": "Trazado 19421",
    d: "M132.907,196.252a4.708,4.708,0,0,1,9.044,0",
    transform: "translate(-104.467 -151.585)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1404",
    "data-name": "L\\xEDnea 1404",
    y1: 8.194,
    transform: "translate(8.638 9.288)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19422",
    "data-name": "Trazado 19422",
    d: "M27.853,5.235a4.219,4.219,0,1,1-5.966,0A4.219,4.219,0,0,1,27.853,5.235Z",
    transform: "translate(-16.232 -3.144)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1405",
    "data-name": "L\\xEDnea 1405",
    x1: 7.966,
    y2: 1.92,
    transform: "translate(16.574 43.707)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19423",
    "data-name": "Trazado 19423",
    d: "M39.217,200.136a4.219,4.219,0,1,1,1.4,5.8A4.219,4.219,0,0,1,39.217,200.136Z",
    transform: "translate(-30.338 -155.724)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1406",
    "data-name": "L\\xEDnea 1406",
    y1: 5.178,
    x2: 5.189,
    transform: "translate(39.931 30.369)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19424",
    "data-name": "Trazado 19424",
    d: "M213.238,115.622a3.774,3.774,0,1,1-3.77-3.778A3.774,3.774,0,0,1,213.238,115.622Z",
    transform: "translate(-161.675 -87.911)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1407",
    "data-name": "L\\xEDnea 1407",
    x1: 1.129,
    y2: 10.279,
    transform: "translate(34.092 21.859)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1408",
    "data-name": "L\\xEDnea 1408",
    x1: 10.105,
    y1: 6.934,
    transform: "translate(14.37 32.138)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplementationBlueprint);
export default __webpack_public_path__ + "static/media/implementationBlueprint.6db579d3bb1ede9202b50ac04735a3b8.svg";
export { ForwardRef as ReactComponent };